var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 5,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.832.686A.539.539 0 0 0 5.431.5a.539.539 0 0 0-.401.186L2.986 2.953.971.686A.539.539 0 0 0 .571.5a.539.539 0 0 0-.402.186.65.65 0 0 0-.125.209.71.71 0 0 0 .125.7l2.413 2.716a.57.57 0 0 0 .185.14.515.515 0 0 0 .438 0 .57.57 0 0 0 .185-.14l2.442-2.716a.65.65 0 0 0 .125-.208.71.71 0 0 0-.125-.7Z"
})));
export default SvgChevronDown;